// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"mobileBoardLane_mulitpleDropdown__2olh8","wrapper":"mobileBoardLane_wrapper__32TY9"};